import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLog = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 8h18V5.5c0-.417-.146-.77-.438-1.063A1.447 1.447 0 0 0 19.5 4h-15c-.417 0-.77.146-1.063.438A1.447 1.447 0 0 0 3 5.5V8zm0 6h18v-4H3v4zm1.5 6h15c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062V16H3v2.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437zM5 7a.968.968 0 0 1-.713-.287A.968.968 0 0 1 4 6c0-.283.096-.52.287-.713A.968.968 0 0 1 5 5c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.968.968 0 0 1 5 7zm0 6a.967.967 0 0 1-.713-.287A.968.968 0 0 1 4 12c0-.283.096-.52.287-.713A.967.967 0 0 1 5 11c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.713A.967.967 0 0 1 5 13zm0 6a.967.967 0 0 1-.713-.288A.968.968 0 0 1 4 18c0-.283.096-.52.287-.712A.967.967 0 0 1 5 17c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.967.967 0 0 1 5 19z",
		fill: "currentColor"
	})
});
export default SvgLog;
